export default __webpack_public_path__ + "static/media/Speaker1.d2dc51ad.png";